module.exports = __webpack_public_path__ + "static/media/5.d67963b3.webp";